import React from "react";

import {
  Box,
  Flex,
  FlexProps,
  IconOnePassBg,
} from "@catchoftheday/cg-components";
import { styled } from "@catchoftheday/theme";

const BgIcon = styled(IconOnePassBg)`
  mix-blend-mode: overlay;
`;

export const OnePassHeader: React.FC<FlexProps> = ({
  children,
  ...flexProps
}) => {
  return (
    <Flex
      position="relative"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      p="30px"
      color="textWhite"
      overflow="hidden"
      fontFamily="onePass"
      backgroundColor="onePass.primaryDarker"
      {...flexProps}
    >
      {children}
      <Box position="absolute" top={0} right={0} height="100%">
        <BgIcon
          name="OnePass background"
          fill="white"
          width="auto"
          height="110%"
          opacity={0.5}
        />
      </Box>
    </Flex>
  );
};

export default OnePassHeader;
